import React from 'react';
import domtoimage from 'dom-to-image';

import imgO from './O.png';
import imgR from './RE.png';

export default class Oreo extends React.Component {
    oreoRef = React.createRef();
    handleDownload = () => {
        domtoimage.toPng(this.oreoRef.current)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'OREO.png';
                link.href = dataUrl;
                link.click();
            });
    }
    render() {
        let props = this.props;
        let oreo = [];
        let top = 0;
        let height_O = 20;
        let height_R = 5;
        props.oreo.split('').forEach((p, index) => {
            if (p === 'O') {
                top += height_O;
                oreo.push(<img key={index} src={imgO} alt="O" style={{ position: "absolute", top: top + "px", width: "100px" }} />);
            }
            if (p === 'R') {
                // top += 14.1;
                top += height_R;
                oreo.push(<img key={index} src={imgR} alt="R" style={{ position: "absolute", top: 23.46 + top + "px", width: "80px", margin: "0px 10px" }} />);
            }
        });
        return <React.Fragment>
            <input type="button" name="Download" onClick={this.handleDownload} value="下载 Download" />
            <br />
            <div style={{ position: "relative", width: "100px", height: 70 + top + 'px', display: 'inline-block', textAlign: 'left' }} ref={this.oreoRef}>
                {oreo.reverse()}
            </div>
        </React.Fragment>;
    }
}